<template>
  <form class="nameform" @submit="next">
    <div class="content content--small">
      <h1 class="mb-6 md:text-center">
        Ben Fatto!
      </h1>
      <p class="f-b">
        Ti chiederemo adesso delle informazioni personali in più. Ecco perchè ci
        servono:
      </p>
      <p class="mt-3">
        Al fine di adempiere gli obblighi di cui al Decreto legislativo 21
        novembre 2007 n. 231 e al Provvedimento di Banca d'Italia del 3 aprile
        2013, ti sottoponiamo ad integrazione delle informazioni già raccolte
        anche il seguente questionario di adeguata verifica della clientela. La
        raccolta di tali informazioni è richiesta dalla legge per una completa
        identificazione ed un'adeguata conoscenza del cliente e dell'eventuale
        titolare effettivo. La normativa impone al cliente di fornire tutte le
        informazioni aggiornate necessarie per l'adempimento degli obblighi di
        legge; in taluni casi non fornire le informazioni o fornirle false
        comporta sanzioni penali.
      </p>
      <div class="flex flex-wrap -mx-3 mt-6">
        <div class="row-switch w-full px-3 mb-6">
          <p class="f-b">
            Dichiaro di agire in proprio confermando di essere l’unico titolare
            effettivo del rapporto.
          </p>
          <label class="switch">
            <input v-model="titolareEffettivo" type="checkbox" />
            <span class="slider round"></span>
          </label>
        </div>
        <span
          class="f-m text-grey label-info ml-3"
          @click="showModalTitolareEffettivo"
          >Perchè mi chiedi questo?</span
        >
      </div>
    </div>
    <div class="page-footer">
      <button class="btn" :disabled="$v.$invalid" type="submit">
        Prosegui
      </button>
    </div>
  </form>
</template>

<script>
import { sameAs } from "vuelidate/lib/validators";

export default {
  name: "TitolareEffettivo",

  data() {
    return {
      titolareEffettivo: this.$store.state.user.titolareEffettivo
    };
  },
  validations: {
    titolareEffettivo: {
      sameAs: sameAs(() => true)
    }
  },
  methods: {
    showModalTitolareEffettivo() {
      this.$root.$emit("openModal", "genericModal", {
        size: "large",
        title: "Definizione",
        message: `Art. 18 (Contenuto degli obblighi di adeguata verifica). — 1. Gli obblighi di adeguata verifica della clientela si attuano attraverso: a) l’identificazione del cliente e la verifica della sua identità attraverso riscontro di un documento d’identità o di altro documento di riconoscimento equipollente ai sensi della normativa vigente nonché sulla base di documenti, dati o informazioni ottenuti da una fonte affidabile e indipendente. Le medesime misure si attuano nei confronti dell’esecutore, anche in relazione alla verifica dell’esistenza e dell’ampiezza del potere di rappresentanza in forza del quale opera in nome e per conto del cliente; (omissis) c) l’acquisizione e la valutazione di informazioni sullo scopo e sulla natura del rapporto continuativo o della prestazione professionale, per tali intendendosi, quelle relative all’instaurazione del rapporto, alle relazioni intercorrenti tra il cliente e l’esecutore, tra il cliente e il titolare effettivo e quelle relative all’attività lavorativa, salva la possibilità di acquisire, in funzione del rischio, ulteriori informazioni, ivi comprese quelle relative alla situazione economico-patrimoniale del cliente, acquisite o possedute in ragione dell’esercizio dell’attività. (omissis) 2. Le attività di identificazione e verifica dell’identità del cliente, dell’esecutore e del titolare effettivo, di cui alle lettere a) e b) del comma 1, sono effettuate prima dell’instaurazione del rapporto continuativo o del conferimento dell’incarico per lo svolgimento di una prestazione professionale ovvero prima dell’esecuzione dell’operazione occasionale.`
      });
    },
    next() {
      //prevent form submit
      event.preventDefault();
      if (this.loading) return;
      this.loading = true;

      this.$store.commit("setUser", {
        titolareEffettivo: this.titolareEffettivo
      });
      this.$root.$emit("submitStep");
    }
  }
};
</script>
<style lang="less" scoped>
.row-switch .switch {
  width: 100px;
  margin-left: 10px;
}
</style>
